module.exports = __webpack_public_path__ + "static/media/my-posts.8facfb36.svg";